var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-card"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((Object.entries(_vm.infos)),function(ref,index){
var label = ref[0];
var value = ref[1];
return _c('info-item',{key:("" + index),attrs:{"name":label,"value":value}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }